var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img_main",style:({backgroundColor:_vm.bgcolor})},[(!_vm.hidden)?_c('div',{staticClass:"bgimg_box",style:({background:'url('+_vm.src+')',backgroundSize:'cover',backgroundPosition:'center center'})}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }